module.exports = __webpack_public_path__ + "img/375.76ad9b05.jpg";